/** 산업 디자인 포트폴리오·상세 */

import { ducatiLaserDesignCase, ducatiLaserPortfolioCard, DUCATI_LASER_SLUG } from './ducatiLaserCaseData'
import { sortPortfolioByYear } from './portfolioYearSort'

export const INDUSTRIAL_DESIGN_PORTFOLIO_PATH = '/codam-design/industrial-design'

export const INDUSTRIAL_DESIGN_PARENT_PATH = '/codam-design'

/** @param {string} slug */
export function industrialDesignCaseHref(slug) {
    return `${INDUSTRIAL_DESIGN_PORTFOLIO_PATH}/${slug}`
}

export const VALID_INDUSTRIAL_DETAIL_SLUGS = new Set([DUCATI_LASER_SLUG])

const industrialPortfolioItemsSource = [ducatiLaserPortfolioCard]

export const industrialPortfolioItems = sortPortfolioByYear(industrialPortfolioItemsSource)

export const industrialCasesBySlug = {
    [DUCATI_LASER_SLUG]: ducatiLaserDesignCase,
}

/** @param {string} slug */
export function getIndustrialCaseBySlug(slug) {
    return industrialCasesBySlug[slug] ?? null
}
